// Others
import { Libraries } from '@react-google-maps/api';
import { dataTimeZone } from '~/utils/helper/common';
import { IBaseOption, IClientContact, IQueryParamBase, ISortBy } from '~/utils/interface/common';
import { DateTypeReportEnum, GroupByEnum, RoleEnum, TypeInventoryGroupDay } from '~/utils/enum/common';
import { adminRouteAbsolute } from '~/utils/routes/roleRoutes/admin';
import { salesAdminRouteAbsolute } from '~/utils/routes/roleRoutes/salesAdmin';
import { salesPersonRouteAbsolute } from '~/utils/routes/roleRoutes/salesPerson';
import { operationsManagerRouteAbsolute } from '~/utils/routes/roleRoutes/operationsManager';
import { warehouseLeadRouteAbsolute } from '~/utils/routes/roleRoutes/warehouseLead';
import { warehouseStaffRouteAbsolute } from '~/utils/routes/roleRoutes/warehouseStaff';
import { foremanRouteAbsolute } from '~/utils/routes/roleRoutes/foreman';
import { crewRouteAbsolute } from '~/utils/routes/roleRoutes/crew';
import { loaderRouteAbsolute } from '~/utils/routes/roleRoutes/loader';

// GoogleMap
export const DEFAULT_GG_MAP_LOAD_SCRIPT_LIB: Libraries = ['places'];

// String
export const QUERY_KEY_TAB = 'tab';
export const ARRAY = 'array';
export const OBJECT = 'object';
export const LANGUAGES = ['en'];
export const EMPTY_STRING = '';
export const EMPTY_VALUE = '-';
export const DOLLAR = '$';
export const FILE_UPLOAD_DEFAULT_ACCEPT_TYPE = '*';
export const FILE_UPLOAD_TYPE_STARTS_WITH_IMAGE = 'image/';
export const CONTENT_TYPE_FORM_DATA = 'multipart/form-data';
export const DEFAULT_VALUE_EMPTY_RICH_EDITOR = '<p><br></p>';
export const DEFAULT_TIME_QUOTE = '09:00';
export const DEFAULT_QUOTE_FILE_NAME_PDF = 'QuoteDocument.pdf';
export const DEFAULT_INVOICE_FILE_NAME_PDF = 'InvoiceDocument.pdf';
export const DEFAULT_ORDER_FILE_NAME_PDF = 'OrderDocument.pdf';
export const PDF_POSITION_PLACEHOLDER_TO_SIGNING = '{{sign|1|*}}';
export const LOADING_OPTION_VALUE = '__loading__-base-autocomplete';
export const ROLE_TYPE_MOBILE = 'auth:mobile';
export const ENTER_KEY = 'Enter';
export const SPACE = ' ';

// Regex
export const REG_EXP = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  NUMBER: /[^\d]/g,
  PHONE_NUMBER: /^\d{10}$/,
  IS_IMAGE: /\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i,
  IS_NUMBER: /^[0-9]*$/,
  NUMBER_MAX_LENGTH_SIX: /^[0-9]{6}$/,
  VERIFY_CODE: /^\d?$/,
  NON_DIGIT_REGEX: /[^\d]/g,
};

// Excel
export const DEFAULT_BOOK_TYPE_XLSX = 'xlsx';
export const DEFAULT_BOOK_TYPE_CSV = 'csv';
export const DEFAULT_TYPE_FILE_EXCEL = 'application/octet-stream';
export const DEFAULT_NAME_SHEET_INVENTORY = 'inventories';

// Colors
export const DEFAULT_OPACITY_HEX_COLOR_KANBAN = '15';

// Number
export const DEFAULT_LIMIT_COUNT_MESSAGE = 99;
export const DEFAULT_CURRENT_PAGE = 1;
export const DEFAULT_LIMIT_PAGE_DASHBOARD = 5;
export const DEFAULT_LIMIT_PAGE = 10;
export const DEFAULT_MUCH_PAGE = 10000;
export const DEFAULT_MAX_PAGE = 1000000;
export const DEFAULT_DELAY_TIME = 1000;
export const DEFAULT_DECIMAL_POINT = 2;
export const FILE_UPLOAD_PROP_MAX_FILE = 10;
export const FILE_UPLOAD_PROP_MIN_FILE = 1;
export const MAX_FILE_SIZE = 10 * 1024 * 1024;
export const DEFAULT_HEIGHT_UPLOAD_IMAGE = 171;
export const RANDOM_RANGE = 1000;
export const BACK_TO_PREVIOUS_PAGE = -1;
export const DEFAULT_INDEX = 1;
export const DEFAULT_LENGTH_OTP = 6;
export const TIME_CLOSE_TOAST = 4000;
export const TIME_OUT_SHOW_TOAST_ERROR = 200;
export const TIME_OUT_SHOW_TOAST_SUCCESS = 1000;
export const DEFAULT_DEBOUNCE_DELAY_TIME = 300;
export const DEFAULT_QUALITY_IMAGE = 0.6;
export const DEFAULT_MAX_HEIGHT_IMAGE = 720;
export const DEFAULT_MAX_WIDTH_IMAGE = 1280;
export const DEFAULT_POSITION = 0.00001;
export const DEFAULT_NUMBER_ZERO = 0;

// Component
export const FILTER_DEFAULT_VALUES: IQueryParamBase = { fields: [] };
export const FILE_UPLOAD_PROP_MULTIPLE = false;
export const FILE_UPLOAD_PROP_REQUIRED = false;

// Ring Central Start
/// Message
export const RING_CENTRAL_TYPE_ACTIVE_CALL_NOTIFY = 'rc-active-call-notify';
export const RING_CENTRAL_TYPE_CALL_END_NOTIFY = 'rc-call-end-notify';
export const RING_CENTRAL_TYPE_CONNECTION_STATUS_NOTIFY = 'rc-webphone-connection-status-notify';
export const RING_CENTRAL_TYPE_LOGIN_STATUS_NOTIFY = 'rc-login-status-notify';

/// Status
export const RING_CENTRAL_TYPE_CONNECTED_STATUS = 'connectionStatus-connected';
export const RING_CENTRAL_TYPE_CONNECTING_STATUS = 'connectionStatus-connecting';
export const RING_CENTRAL_TYPE_DISCONNECTED_STATUS = 'connectionStatus-disconnected';
export const RING_CENTRAL_TYPE_RINGING_TELEPHONY_STATUS = 'Ringing';

/// Adapter
export const RING_CENTRAL_TYPE_REGISTER_SERVICE_ADAPTER = 'rc-adapter-register-third-party-service';
export const RING_CENTRAL_TYPE_NEW_CALL_ADAPTER = 'rc-adapter-new-call';
export const RING_CENTRAL_TYPE_LOGIN_ADAPTER = 'rc-adapter-login';
export const RING_CENTRAL_TYPE_LOGOUT_ADAPTER = 'rc-adapter-logout';
export const RING_CENTRAL_TYPE_NEW_SMS_ADAPTER = 'rc-adapter-new-sms';
export const RING_CENTRAL_TYPE_WIDGET_FRAME_ADAPTER = '#rc-widget-adapter-frame';

// Base Select Dynamic Options
export const DEFAULT_SELECT_DYNAMIC_IS_SEARCH = true;
export const DEFAULT_SELECT_DYNAMIC_RESULT_FETCH_DATA = { optionsResp: [], hasMoreResp: false };

// Options
export const commonOptionStatus: IBaseOption[] = [
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'In Active',
    value: 'inactive',
  },
];

export const optionsDepositMade: IBaseOption[] = [
  {
    label: 'Not Required',
    value: 'not required',
  },
  {
    label: 'Rental Order Deposit (30%)',
    value: 'rental order deposit',
  },
  {
    label: 'Washing Order Deposit (50%)',
    value: 'washing order deposit',
  },
];

export const optionsReferralSource: IBaseOption[] = [
  {
    label: 'Facebook',
    value: 'Facebook',
  },
  {
    label: 'Google',
    value: 'Google',
  },
  {
    label: 'Instagram',
    value: 'Instagram',
  },
  {
    label: 'Wedding Planners',
    value: 'Wedding Planners',
  },
  {
    label: 'Wedding Wire/Knot',
    value: 'Wedding Wire/Knot',
  },
  {
    label: 'Word of Mouth',
    value: 'Word of Mouth',
  },
];

export const optionsTimeLimitQuote: IBaseOption[] = [
  {
    label: 'No Later Than',
    value: 'No later than',
  },
  {
    label: 'No Earlier Than',
    value: 'No Earlier Than',
  },
  {
    label: 'On Time',
    value: 'On Time',
  },
];

export const optionsRepeatBusiness: IBaseOption[] = [
  {
    label: 'Repeat Business',
    value: 'Repeat Business',
  },
  {
    label: 'New Business',
    value: 'New Business',
  },
];

export const optionsDeliveryOrPickUp: IBaseOption[] = [
  {
    label: 'We Deliver & Pick-Up',
    value: 'We Deliver & Pick-Up',
  },
  {
    label: 'Customer Delivers & Picks-Up',
    value: 'Customer Delivers & Picks-Up',
  },
];

export const optionsPricing: IBaseOption[] = [
  {
    label: '1',
    value: '1',
  },
  {
    label: '1.5',
    value: '1.5',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
];

// Jobs
export const optionsTypePage: IBaseOption[] = [
  {
    label: 'Kanban',
    value: 'KANBAN',
  },
  {
    label: 'List',
    value: 'LIST',
  },
];

export const optionsTypePriority: IBaseOption[] = [
  {
    label: 'High',
    value: 'high',
  },
  {
    label: 'Medium',
    value: 'medium',
  },
  {
    label: 'Low',
    value: 'low',
  },
];

export const optionsTypeIncident: IBaseOption[] = [
  {
    label: 'Equipment Malfunction',
    value: 'malfunction',
  },
  {
    label: 'Customer Complaint',
    value: 'complaint',
  },
  {
    label: 'Special Request',
    value: 'request',
  },
];

// Users
export const optionsStatusUser: IBaseOption[] = [
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'Inactive',
    value: 'inactive',
  },
];

// Quotes
export const optionsStatusQuotes: IBaseOption[] = [
  {
    label: 'In Process',
    value: 'in process',
  },
  {
    label: 'Pending Approval',
    value: 'pending approval',
  },
  {
    label: 'Completed',
    value: 'completed',
  },
  {
    label: 'Quote Expired',
    value: 'quote expired',
  },
  {
    label: 'Quote Cancelled',
    value: 'quote cancelled',
  },
];

export const optionTimezone: IBaseOption[] = [
  {
    label: dataTimeZone(),
    value: dataTimeZone(),
  },
];

export const optionDiscountType: IBaseOption[] = [
  {
    label: '%',
    value: 'percentage',
  },
  {
    label: '$',
    value: 'amount',
  },
];

export const optionStatusInventory: IBaseOption[] = [
  {
    label: 'Available',
    value: 'available',
  },
  {
    label: 'Unavailable',
    value: 'unavailable',
  },
];

export const optionProductDesignation: IBaseOption[] = [
  {
    label: 'Furniture',
    value: 'furniture',
  },
  {
    label: 'Tent',
    value: 'tent',
  },
];

export const optionTruckType: IBaseOption[] = [
  {
    label: '5th Wheel',
    value: '5th Wheel',
  },
  {
    label: 'Flat Bed (Hino)',
    value: 'Flat Bed (Hino)',
  },
  {
    label: 'Flat Bed',
    value: 'Flat Bed',
  },
  {
    label: 'Rest Room',
    value: 'Rest Room',
  },
  {
    label: 'Box Truck',
    value: 'Box Truck',
  },
];

export const optionTrailerType: IBaseOption[] = [
  {
    label: '5th Wheel Enclosed',
    value: '5th Wheel Enclosed',
  },
  {
    label: 'Flat Bed (Hino)',
    value: 'Flat Bed (Hino)',
  },
  {
    label: 'Flat Bed',
    value: 'Flat Bed',
  },
];

export const optionEquipmentType: IBaseOption[] = [
  {
    label: 'Flatbed',
    value: 'Flatbed',
  },
  {
    label: 'Restroom trailers',
    value: 'Restroom trailers',
  },
  {
    label: '5th wheel',
    value: '5th wheel',
  },
  {
    label: 'Auxiliary',
    value: 'Auxiliary',
  },
];

export const optionRentalStatus: IBaseOption[] = [
  {
    label: 'Permanent',
    value: 'Permanent',
  },
  {
    label: 'Temporary Rental',
    value: 'Temporary Rental',
  },
];

export const optionReason: IBaseOption[] = [
  {
    label: 'Updated Count',
    value: 'updated count',
  },
  {
    label: 'Purchased New Product',
    value: 'purchased new product',
  },
];

export const optionBusinessTypeClient: IBaseOption[] = [
  {
    label: 'Residential',
    value: 'residential',
  },
  {
    label: 'Institutional',
    value: 'institutional',
  },
];

export const optionContactTypeClient: IBaseOption[] = [
  {
    label: 'Primary Contact',
    value: 'primary contact',
  },
  {
    label: 'Sale Contact',
    value: 'sale contact',
  },
  {
    label: 'Billing Contact',
    value: 'billing contact',
  },
];

export const optionMethodDelivery: IBaseOption[] = [
  {
    label: 'Delivered By Vendor',
    value: 'delivered by vendor',
  },
  {
    label: 'Picked Up By Company',
    value: 'picked up by company',
  },
];

export const optionTypePO: IBaseOption[] = [
  {
    label: 'Purchase',
    value: 'purchase',
  },
  {
    label: 'Sub Rental',
    value: 'sub rental',
  },
];

export const optionPickupType: IBaseOption[] = [
  {
    label: 'Pick up by vendor',
    value: 'pick up by vendor',
  },
  {
    label: 'Returned by company',
    value: 'returned by company',
  },
];

export const optionDeliveryTo: IBaseOption[] = [
  {
    label: 'Delivery address',
    value: 'delivery address',
  },
  {
    label: 'Company warehouse',
    value: 'company warehouse',
  },
];

export const optionStatusOrder: IBaseOption[] = [
  {
    label: 'Hold',
    value: 'hold',
  },
  {
    label: 'Pending',
    value: 'pending',
  },
  {
    label: 'Booked',
    value: 'booked',
  },
  {
    label: 'Finalized',
    value: 'finalized',
  },
];

export const optionPaymentTerms: IBaseOption[] = [
  {
    label: 'Pay in full prior to delivery',
    value: 'full prepayment',
  },
  {
    label: 'Net 30',
    value: 'net 30',
  },
];

export const optionStatusInvoice: IBaseOption[] = [
  {
    label: 'Draft',
    value: 'draft',
  },
  {
    label: 'Pending',
    value: 'pending',
  },
  {
    label: 'Partial',
    value: 'partial',
  },
  {
    label: 'Paid',
    value: 'paid',
  },
  {
    label: 'Overdue',
    value: 'overdue',
  },
  {
    label: 'Canceled',
    value: 'canceled',
  },
];

export const optionSiteType: IBaseOption[] = [
  {
    label: 'Private Residence',
    value: 'private residence',
  },
  {
    label: 'Venue',
    value: 'venue',
  },
  {
    label: 'Rental Property',
    value: 'rental property',
  },
  {
    label: 'Commercial',
    value: 'commercial',
  },
  {
    label: 'Park',
    value: 'park',
  },
  {
    label: 'School',
    value: 'school',
  },
];

export const optionColor: IBaseOption[] = [
  { label: 'Red', value: 'red' },
  { label: 'Blue', value: 'blue' },
  { label: 'Green', value: 'green' },
  { label: 'Yellow', value: 'yellow' },
  { label: 'Orange', value: 'orange' },
  { label: 'Purple', value: 'purple' },
  { label: 'Pink', value: 'pink' },
  { label: 'Brown', value: 'brown' },
  { label: 'Black', value: 'black' },
  { label: 'White', value: 'white' },
  { label: 'Gray', value: 'gray' },
  { label: 'Cyan', value: 'cyan' },
  { label: 'Magenta', value: 'magenta' },
  { label: 'Lime', value: 'lime' },
  { label: 'Teal', value: 'teal' },
  { label: 'Navy', value: 'navy' },
  { label: 'Maroon', value: 'maroon' },
  { label: 'Olive', value: 'olive' },
  { label: 'Silver', value: 'silver' },
  { label: 'Gold', value: 'gold' },
];

// Sort
export const DEFAULT_SORT_USER: ISortBy[] = [{ name: 'id' }, { name: 'name' }, { name: 'role' }, { name: 'status' }];

export const DEFAULT_SORT_TASK: ISortBy[] = [
  { name: 'title' },
  { name: 'assignees' },
  { name: 'due date' },
  { name: 'priority' },
  { name: 'status' },
  { name: 'progress' },
];

export const DEFAULT_SORT_APPOINTMENT: ISortBy[] = [
  { name: 'title' },
  { name: 'type' },
  { name: 'date' },
  { name: 'start time' },
  { name: 'location' },
  { name: 'status' },
];

export const DEFAULT_SORT_QUOTE: ISortBy[] = [
  { name: 'id' },
  { name: 'client' },
  { name: 'start date' },
  { name: 'end date' },
  { name: 'created by' },
  { name: 'quote amount' },
  { name: 'status' },
  { name: 'type' },
];

export const DEFAULT_SORT_INVENTORY: ISortBy[] = [
  { name: 'name' },
  { name: 'category' },
  { name: 'brand' },
  { name: 'available' },
  { name: 'rental price' },
  { name: 'status' },
  { name: 'variant name' },
];

export const DEFAULT_SORT_PACKAGE: ISortBy[] = [
  { name: 'id' },
  { name: 'title' },
  { name: 'rental price' },
  { name: 'description' },
  { name: 'note' },
];

export const DEFAULT_SORT_QUARANTINE: ISortBy[] = [
  { name: 'product name' },
  { name: 'variant name' },
  { name: 'type' },
  { name: 'description' },
  { name: 'quantity' },
  { name: 'repaired quantity' },
  { name: 'broken quantity' },
  { name: 'start date' },
  { name: 'end date' },
];

export const DEFAULT_SORT_COUPON: ISortBy[] = [
  { name: 'name' },
  { name: 'discount rate' },
  { name: 'discount type' },
  { name: 'quantity' },
  { name: 'start date' },
  { name: 'end date' },
  { name: 'status' },
];
export const DEFAULT_SORT_TRUCK: ISortBy[] = [
  { name: 'name' },
  { name: 'truck type' },
  { name: 'number of seats' },
  { name: 'status' },
  { name: 'rental status' },
];

export const DEFAULT_SORT_TRAILER: ISortBy[] = [
  { name: 'name' },
  { name: 'trailer type' },
  { name: 'note' },
  { name: 'status' },
  { name: 'rental status' },
];

export const DEFAULT_SORT_EQUIPMENT: ISortBy[] = [
  { name: 'name' },
  { name: 'equipment type' },
  { name: 'note' },
  { name: 'status' },
  { name: 'rental status' },
];

export const DEFAULT_SORT_PURCHASE_ORDER: ISortBy[] = [
  { name: 'name' },
  { name: 'po number' },
  { name: 'needed by' },
  { name: 'order' },
  { name: 'status' },
  { name: 'type' },
  { name: 'method' },
  { name: 'vendor type' },
  { name: 'approved by' },
];

export const DEFAULT_SORT_CLIENT: ISortBy[] = [
  { name: 'id' },
  { name: 'name' },
  { name: 'company name' },
  { name: 'phone number' },
  { name: 'email' },
  { name: 'address' },
  { name: 'amount' },
  { name: 'type' },
  { name: 'assigned to' },
  { name: 'last contacted' },
  { name: 'follow up due' },
  { name: 'status' },
];

export const DEFAULT_SORT_ORDER: ISortBy[] = [
  { name: 'order number' },
  { name: 'event name' },
  { name: 'client name' },
  { name: 'start date' },
  { name: 'end date' },
  { name: 'client address' },
  { name: 'delivery address' },
  { name: 'pickup address' },
  { name: 'po number' },
  { name: 'status' },
  { name: 'total' },
];

export const DEFAULT_SORT_VENDOR: ISortBy[] = [
  { name: 'name' },
  { name: 'email' },
  { name: 'phone' },
  { name: 'contact name' },
  { name: 'address' },
  { name: 'type' },
];

export const DEFAULT_SORT_JOB: ISortBy[] = [
  { name: 'id' },
  { name: 'title' },
  { name: 'client' },
  { name: 'timeline' },
  { name: 'delivery address' },
  { name: 'pickup address' },
  { name: 'assignee' },
  { name: 'amount' },
  { name: 'bal due' },
  { name: 'status' },
];

export const DEFAULT_SORT_INVOICE: ISortBy[] = [
  { name: 'invoice number' },
  { name: 'client' },
  { name: 'total' },
  { name: 'amount paid' },
  { name: 'balance due' },
  { name: 'term' },
  { name: 'status' },
  { name: 'invoice date' },
  { name: 'due date' },
];

export const DEFAULT_SORT_INVOICE_CLIENT: ISortBy[] = [
  { name: 'id' },
  { name: 'event title' },
  { name: 'quote number' },
  { name: 'client' },
  { name: 'start date' },
  { name: 'end date' },
  { name: 'created by' },
  { name: 'quote amount' },
  { name: 'status' },
];

export const DEFAULT_SORT_ROLE: ISortBy[] = [
  { name: 'id' },
  { name: 'name' },
  { name: 'description' },
  { name: 'create at' },
  { name: 'permissions' },
  { name: 'users' },
];

// Object
export const defaultContact: IClientContact = {
  countryCode: EMPTY_STRING,
  email: EMPTY_STRING,
};

// Options Rich Editor
export const toolbarOptionsRichEditor = [
  [
    { header: [1, 2, 3, 4, 5, 6, false] },
    'bold',
    'italic',
    'underline',
    'strike',
    {
      color: [
        '#000000',
        '#e60000',
        '#ff9900',
        '#ffff00',
        '#008a00',
        '#0066cc',
        '#9933ff',
        '#ffffff',
        '#facccc',
        '#ffebcc',
        '#ffffcc',
        '#cce8cc',
        '#cce0f5',
        '#ebd6ff',
        '#bbbbbb',
        '#f06666',
        '#ffc266',
        '#ffff66',
        '#66b966',
        '#66a3e0',
        '#c285ff',
        '#888888',
        '#a10000',
        '#b26b00',
        '#b2b200',
        '#006100',
        '#0047b2',
        '#6b24b2',
        '#444444',
        '#5c0000',
        '#663d00',
        '#666600',
        '#003700',
        '#002966',
        '#3d1466',
      ],
    },
    { list: 'ordered' },
    { list: 'bullet' },
    { indent: '-1' },
    { indent: '+1' },
    { script: 'sub' },
    { script: 'super' },
    'link',
    'image',
  ],
];

export const optionVendorType: IBaseOption[] = [
  {
    label: 'Supplier',
    value: 'Supplier',
  },
  {
    label: 'Sub Rental',
    value: 'Sub Rental',
  },
];

export const optionAppointmentType: IBaseOption[] = [
  { label: 'Meeting', value: 'Meeting' },
  { label: 'Site Visit', value: 'Site Visit' },
];

export const optionAppointmentStatus: IBaseOption[] = [
  { label: 'Scheduled', value: 'Scheduled' },
  { label: 'Completed', value: 'Completed' },
  { label: 'Requested', value: 'Requested' },
];

export const optionPaymentMethod: IBaseOption[] = [
  { label: 'Cash', value: 'Cash' },
  { label: 'Check', value: 'Check' },
  { label: 'Card', value: 'Card' },
];

export const optionTaskStatus: IBaseOption[] = [
  { label: 'New', value: 'new' },
  { label: 'Pending', value: 'pending' },
  { label: 'Scheduled', value: 'scheduled' },
  { label: 'In Progress', value: 'in progress' },
  { label: 'Completed', value: 'completed' },
];

export const optionTaskPriority: IBaseOption[] = [
  { label: 'High', value: 'high' },
  { label: 'Medium', value: 'medium' },
  { label: 'Low', value: 'low' },
];

export const optionTaskTag: IBaseOption[] = [
  { label: 'Technical', value: 'technical' },
  { label: 'Planning', value: 'planning' },
  { label: 'Meeting', value: 'meeting' },
  { label: 'Client', value: 'client' },
];

export const optionQuarantineType: IBaseOption[] = [
  {
    label: 'Damage',
    value: 'Damage',
  },
  {
    label: 'Other',
    value: 'Other',
  },
  {
    label: 'Maintenance',
    value: 'Maintenance',
  },
];

export const optionsCommonUnit: IBaseOption[] = [
  {
    label: 'Percentage (%)',
    value: 'percentage',
  },
  {
    label: 'Amount ($)',
    value: 'amount',
  },
];

export const optionStatusPO: IBaseOption[] = [
  {
    label: 'Approved',
    value: 'approved',
  },
  {
    label: 'Cancelled',
    value: 'cancelled',
  },
  {
    label: 'Open',
    value: 'open',
  },
  {
    label: 'Pending Delivery',
    value: 'pending delivery',
  },
  {
    label: 'Received',
    value: 'received',
  },
  {
    label: 'Closed',
    value: 'closed',
  },
];

export const optionAvailableOrderEvent: IBaseOption[] = [
  {
    label: 'All',
    value: 'All',
  },
  {
    label: 'Available',
    value: 'Available',
  },
];

export const optionStatusJobKanban: IBaseOption[] = [
  {
    label: 'Finalized',
    value: 'finalized',
  },
  {
    label: 'Scheduled',
    value: 'scheduled',
  },
  {
    label: 'Delivery Incomplete',
    value: 'delivery incomplete',
  },
  {
    label: 'Loaded',
    value: 'loaded',
  },
  {
    label: 'Delivered',
    value: 'delivered',
  },
  {
    label: 'Picked Up',
    value: 'picked up',
  },
  {
    label: 'Returned',
    value: 'returned',
  },
  {
    label: 'Picked Up Incomplete',
    value: 'picked up incomplete',
  },
  {
    label: 'Invoiced',
    value: 'invoiced',
  },
  {
    label: 'Complete',
    value: 'complete',
  },
];

export const colorsRevenueReport = ['#2D80FC', '#FEA500', '#77B900', '#F86B38'];

export const optionViewReport: IBaseOption[] = [
  {
    label: 'Day',
    value: 'day',
  },
  {
    label: 'Month',
    value: 'month',
  },
  {
    label: 'Year',
    value: 'year',
  },
];

export const optionGroupBy: IBaseOption[] = [
  {
    label: 'Order',
    value: GroupByEnum.ORDER,
  },
  {
    label: 'Product',
    value: GroupByEnum.PRODUCT,
  },
];

export const optionTransactionType: IBaseOption[] = [
  {
    label: 'All Status',
    value: 'all',
  },
  {
    label: 'Order',
    value: 'order',
  },
  {
    label: 'Quote',
    value: 'quote',
  },
];

export const optionDateType: IBaseOption[] = [
  {
    label: 'Cancellation Date',
    value: DateTypeReportEnum.CANCELLATION,
  },
  {
    label: 'Start Date',
    value: DateTypeReportEnum.START_DATE,
  },
];

export const optionDateTypeDeliveryReport: IBaseOption[] = [
  {
    label: 'Created At',
    value: DateTypeReportEnum.CREATED_AT,
  },
  {
    label: 'Start Date',
    value: DateTypeReportEnum.START_DATE,
  },
  {
    label: 'Event Date',
    value: DateTypeReportEnum.EVENT_DATE,
  },
];

export const optionDateTypeSubRentalReport: IBaseOption[] = [
  {
    label: 'Created At',
    value: DateTypeReportEnum.CREATED_AT,
  },
  {
    label: 'Needed By',
    value: DateTypeReportEnum.NEEDED_BY,
  },
];

export const IMAGE_MIME_TYPES: Record<string, string[]> = {
  'image/png': ['png'],
  'image/jpeg': ['jpeg', 'jpg'],
  'image/gif': ['gif'],
  'image/webp': ['webp'],
  'image/svg+xml': ['svg'],
};

export const DAY_ICON_CONFIG = {
  [TypeInventoryGroupDay.ALL]: [
    { label: 'Q', type: TypeInventoryGroupDay.QUOTE },
    { label: 'O', type: TypeInventoryGroupDay.ORDER },
  ],
  [TypeInventoryGroupDay.QUOTE]: [{ label: 'Q', type: TypeInventoryGroupDay.QUOTE }],
  [TypeInventoryGroupDay.ORDER]: [{ label: 'O', type: TypeInventoryGroupDay.ORDER }],
} as const;

export const roleDetailOrderRouteMap: Partial<Record<RoleEnum, (orderId: string) => string>> = {
  [RoleEnum.SUPER_ADMIN]: adminRouteAbsolute.detailOrder,
  [RoleEnum.SALES_ADMIN]: salesAdminRouteAbsolute.detailOrder,
  [RoleEnum.SALES_PERSON]: salesPersonRouteAbsolute.detailOrder,
  [RoleEnum.OPERATIONS_MANAGER]: operationsManagerRouteAbsolute.detailOrder,
  [RoleEnum.WAREHOUSE_LEAD]: warehouseLeadRouteAbsolute.detailOrder,
  [RoleEnum.WAREHOUSE_STAFF]: warehouseStaffRouteAbsolute.detailOrder,
  [RoleEnum.FOREMAN]: foremanRouteAbsolute.detailOrder,
  [RoleEnum.CREW]: crewRouteAbsolute.detailOrder,
  [RoleEnum.LOADER]: loaderRouteAbsolute.detailOrder,
};
